import { useEffect } from 'react';

const useClickOutside = (containerRef, isContainerOpen, closeContainer) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        closeContainer();
      }
    };

    if (isContainerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isContainerOpen, containerRef, closeContainer]);
};

export default useClickOutside;
